import { createAsyncThunk } from '@reduxjs/toolkit';
import { ILogisticsConfig } from '..';
import { IState } from '../..';
import { httpService } from '../../..';
import { ApiUrls } from '../../ApiUrls';
import { executeApiRequest } from '../../asyncUtils';
import { showFailedRequestDialogThunk } from '../../thunkUtils';
import { uiActionCreators } from '../../ui';

export const updateLogisticsConfigThunk = createAsyncThunk(
  'config/updateLogistics',
  async (config: ILogisticsConfig, { dispatch, rejectWithValue, getState }) => {
    dispatch(uiActionCreators.showSpinnerDialog());
    const response = await executeApiRequest<ILogisticsConfig>(() =>
      httpService.post(ApiUrls.logisticsAdmin({ config: true }), config)
    );
    dispatch(uiActionCreators.hideSpinnerDialog());

    if (response.requestFailed) {
      showFailedRequestDialogThunk(response, getState() as IState, dispatch);
      return rejectWithValue('Failed to update logistics config');
    }

    return response.value ? { logistics: response.value } : undefined;
  }
);
